export default __webpack_public_path__ + "static/media/biocharm1.17581697.jpg";